// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import Chat from "../components/chat.js";
// import Layout from "../components/layout.js";
// import { IoClose } from "react-icons/io5";
// import { RxHamburgerMenu } from "react-icons/rx";
// import { TbChevronRight } from "react-icons/tb";
// import { TbChevronLeft } from "react-icons/tb";
// import { CgProfile } from "react-icons/cg";
// import { apiurl } from "../config/config.js";
// import { getCookie } from "../config/webStorage.js";

// const Chats = () => {
//     const token = getCookie("sctoken");

//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [conversations, setConversations] = useState([]);
//   const [selectedConversationPhone, setselectedConversationPhone] = useState(null);

//   // console.log("conversations",conversations)
//   console.log("selectedConversationPhone",selectedConversationPhone)

//   const [loading, setLoading] = useState(true);

//   // Fetch conversations from API
//   useEffect(() => {
//     const fetchConversations = async () => {
//       try {
//         const response = await axios.post(
//           `${apiurl}/apis/analytics/customerchat`,
//           {},
//           {
//             headers: {
//               Authorization: `Bearer ${token}`
//             }
//           }
//         );
//         if (response.data.success) {
//           setConversations(response.data.data);
//         }
//       } catch (error) {
//         console.error('Error fetching conversations:', error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchConversations();
//   }, []);

//   // Handle conversation selection
//   const handleConversationSelect = (conversationId) => {
//     setselectedConversationPhone(conversationId);
//     // setIsMenuOpen(false); // Close menu on mobile
//   };

//   // Get last message and sender
//   const getLastMessage = (conversation) => {
//     if (conversation.length === 0) return { message: '', sender: '' };
//     const lastMsg = conversation[conversation.length - 1];
//     return {
//       message: typeof lastMsg.message === 'string' ? lastMsg.message : JSON.stringify(lastMsg.message),
//       sender: lastMsg.sender
//     };
//   };

//   return (
//     <Layout>
//       <div
//         className="layout h-full w-full overflow-hidden bg-zinc-50"
//       >
//         <div className="flex h-full md:p-1">
//           <div
//             className={`sm:relative transition-all duration-500 ease-in-out sm:translate-x-0 z-20 pb-8 overflow-hidden ${
//               isMenuOpen
//                 ? "absolute flex w-[75%] md:w-[45%] lg:w-[25%] z-40 opacity-100 translate-x-0 px-3"
//                 : "absolute flex w-[0%] -translate-x-full opacity-0 sm:opacity-100"
//             } md:flex flex-row md:relative gap-4 items-center h-full pt-2 shadow-sm bg-primary`}
//           >
//             <div className="flex flex-col gap-2 items-center w-full h-full overflow-y-scroll hide-scrollbar">
//               <p className="text-xl text-white text-start w-full">Chatlist</p>
//               {loading ? (
//                 <p className="text-white">Loading...</p>
//               ) : conversations.length === 0 ? (
//                 <p className="text-white">No conversations found</p>
//               ) : (
//                 conversations.map((conv) => {
//                   // const { message, sender } = getLastMessage(conv.conversation);
//                   return (
//                     <div
//                       key={conv._id}
//                       className="px-4 flex items-center py-1 border border-white rounded-md w-full text-start cursor-pointer hover:bg-gray-700"
//                       onClick={() => handleConversationSelect(conv._id)}
//                     >
//                       <div className="rounded-full w-6 h-6 border border-white mr-4 flex justify-center items-center flex-shrink-0">
//                         <img src="defaultprofile.png" alt="profile" className="w-full h-full rounded-full object-cover" />
//                       </div>
//                       <div className="w-full">
//                         <p className="text-sm text-white">{conv?.name || "Unknown" } </p>
//                         <p className="text-xs text-white">{conv.phone}</p>
//                         {/* <p className="text-xs text-slate-400 truncate">{message}</p> */}
//                         {/* <p className="text-xs text-slate-400">{sender}</p> */}
//                       </div>
//                     </div>
//                   );
//                 })
//               )}
//             </div>
//             <div className="bg-primary p-2 md:hidden flex">
//               {isMenuOpen ? (
//                 <div
//                   className="text-2xl text-secondary cursor-pointer"
//                   onClick={() => setIsMenuOpen(false)}
//                 >
//                   <TbChevronLeft className="text-xl" />
//                 </div>
//               ) : (
//                 <div className="py-2 text-secondary cursor-pointer">
//                   <TbChevronRight onClick={() => setIsMenuOpen(true)} className="text-xl" />
//                 </div>
//               )}
//             </div>
//           </div>
//           <div className="bg-primary p-2 h-full flex items-center justify-center">
//             {isMenuOpen ? (
//               <div
//                 className="text-2xl text-secondary cursor-pointer"
//                 onClick={() => setIsMenuOpen(false)}
//               >
//                 <TbChevronLeft className="text-xl" />
//               </div>
//             ) : (
//               <div className="cursor-pointer text-secondary">
//                 <TbChevronRight onClick={() => setIsMenuOpen(true)} className="text-xl" />
//               </div>
//             )}
//           </div>

//           <div className="w-full flex flex-col overflow-hidden h-full border border-primary">
//             {isMenuOpen && (
//               <div
//                 className="block lg:hidden w-full h-full fixed backdrop-blur-[0.2rem] z-30"
//                 onClick={() => setIsMenuOpen(false)}
//               ></div>
//             )}
//             <div className="h-[95vh] overflow-hidden">
//               {selectedConversationPhone ? (
//                 <Chat conversationId={selectedConversationPhone} />
//               ) : (
//                 <div className="h-full flex items-center justify-center">
//                   <p className="text-gray-500">Select a conversation to view</p>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </Layout>
//   );
// };

// export default Chats;
























import React, { useState, useEffect } from "react";
import axios from "axios";
import Chat from "../components/chat.js";
import Layout from "../components/layout.js";
import { TbChevronRight } from "react-icons/tb";
import { TbChevronLeft } from "react-icons/tb";
import { apiurl } from "../config/config.js";
import { getCookie } from "../config/webStorage.js";

const Chats = () => {
  const token = getCookie("sctoken");

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [conversations, setConversations] = useState([]);
  const [selectedConversationPhone, setselectedConversationPhone] = useState(null);
  const [searchQuery, setSearchQuery] = useState(""); // New state for search input
  const [loading, setLoading] = useState(true);

  console.log("selectedConversationPhone", selectedConversationPhone);

  // Fetch conversations from API
  useEffect(() => {
    const fetchConversations = async () => {
      try {
        const response = await axios.post(
          // `${apiurl}/apis/analytics/customerchat`,
          `${apiurl}/apis/getAllCoversation`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.data.success) {
          setConversations(response.data.conversations);
        }
      } catch (error) {
        console.error("Error fetching conversations:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchConversations();
  }, [token]);

  // Handle conversation selection
  const handleConversationSelect = (conversationPhone) => {
    setselectedConversationPhone(conversationPhone);
    // setIsMenuOpen(false); // Close menu on mobile
  };

  // Get last message and sender
  // const getLastMessage = (conversation) => {
  //   if (conversation.length === 0) return { message: "", sender: "" };
  //   const lastMsg = conversation[conversation.length - 1];
  //   return {
  //     message:
  //       typeof lastMsg.message === "string"
  //         ? lastMsg.message
  //         : JSON.stringify(lastMsg.message),
  //     sender: lastMsg.sender,
  //   };
  // };

  // Filter conversations based on search query
  const filteredConversations = conversations.filter((conv) => {
    const name = conv.name || "Unknown";
    const phone = conv.phone || "";
    const query = searchQuery.toLowerCase();
    return (
      name.toLowerCase().includes(query) || phone.toLowerCase().includes(query)
    );
  });

  return (
    <Layout>
      <div className="layout h-full w-full overflow-hidden bg-zinc-50">
        <div className="flex h-full md:p-1">
          <div
            className={`sm:relative transition-all duration-500 ease-in-out sm:translate-x-0 z-20 pb-8 overflow-hidden ${isMenuOpen
              ? "absolute flex w-[75%] md:w-[45%] lg:w-[25%] z-40 opacity-100 translate-x-0 px-3"
              : "absolute flex w-[0%] -translate-x-full opacity-0 sm:opacity-100"
              } md:flex flex-row md:relative gap-4 items-center h-full pt-2 shadow-sm bg-primary`}
          >
            <div className="flex flex-col w-full h-full">
              <div className="flex-shrink-0 px-3 pt-2 bg-primary">
                <p className="text-xl text-white text-start w-full">Chatlist</p>
                <input
                  type="text"
                  placeholder="Search by name or phone"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full p-2 mb-2 text-sm text-gray-700 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-secondary"
                />
              </div>
              <div className="flex-1 overflow-y-auto hide-scrollbar px-3">
                {loading ? (
                  <p className="text-white">Loading...</p>
                ) : filteredConversations.length === 0 ? (
                  <p className="text-white">No conversations found</p>
                ) : (
                  filteredConversations.map((conv) => {
                    // const { message, sender } = getLastMessage(conv.conversation);
                    return (
                      <div
                        key={conv._id}
                        className="px-4 flex items-center overflow-hidden py-1 border border-white rounded-md w-full text-start cursor-pointer hover:bg-gray-700 mb-2"
                        onClick={() => handleConversationSelect(conv.phone)}
                      >
                        <div className="rounded-full w-6 h-6 border border-white mr-4 flex justify-center items-center flex-shrink-0">
                          <img
                            src="/defaultProfile.png"
                            alt="profile"
                            className="w-full h-full rounded-full object-cover"
                          />
                        </div>
                        <div className="w-full">
                          <p className="text-sm text-white">
                            {conv?.name || "Unknown"}
                          </p>
                          {/* <p className="text-xs text-white">
                            {`${'*'.repeat(conv.phone.length - 4)}${conv.phone.slice(-4)}`}
                          </p> */}
                          <p className="text-xs text-white">{conv.phone}</p>
                          {/* <p className="text-xs text-slate-400 truncate">{message}</p> */}
                          {/* <p className="text-xs text-slate-400">{sender}</p> */}
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </div>
            <div className="bg-primary p-2 md:hidden flex">
              {isMenuOpen ? (
                <div
                  className="text-2xl text-secondary cursor-pointer"
                  onClick={() => setIsMenuOpen(false)}
                >
                  <TbChevronLeft className="text-xl" />
                </div>
              ) : (
                <div className="py-2 text-secondary cursor-pointer">
                  <TbChevronRight
                    onClick={() => setIsMenuOpen(true)}
                    className="text-xl"
                  />
                </div>
              )}
            </div>
          </div>
          <div className="bg-primary p-2 h-full flex items-center justify-center">
            {isMenuOpen ? (
              <div
                className="text-2xl text-secondary cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                <TbChevronLeft className="text-xl" />
              </div>
            ) : (
              <div className="cursor-pointer text-secondary">
                <TbChevronRight
                  onClick={() => setIsMenuOpen(true)}
                  className="text-xl"
                />
              </div>
            )}
          </div>

          <div className="w-full flex flex-col overflow-hidden h-full border border-primary">
            {isMenuOpen && (
              <div
                className="block lg:hidden w-full h-full fixed backdrop-blur-[0.2rem] z-30"
                onClick={() => setIsMenuOpen(false)}
              ></div>
            )}
            <div className="h-[95vh] overflow-hidden">
              {selectedConversationPhone ? (
                <Chat conversationPhone={selectedConversationPhone} />
              ) : (
                <div className="h-full flex flex-col items-center justify-center">
                  <img src="/selectChat.png" alt="Select Chat" className="w-60 md:w-72 lg:w-80 xl:w-96 h-auto"/>
                  <p className="text-gray-500">Select a conversation to view</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Chats;